import { Component } from '@angular/core'
import { Checkout, Depot } from 'depoto-core/src/entities/index'
import { CoreService } from '../../../../services'
import { Emittable, Emitter } from '@ngxs-labs/emitter'
import { PlugplayState } from '../../states/plugplay-state.service'

@Component({
  selector: 'app-test-aaa',
  templateUrl: './step1.component.html',
  styleUrls: ['./step1.component.scss'],
})
export class Step1Component {
  @Emitter(PlugplayState.setActive)
  private readonly setActive: Emittable<number>
  @Emitter(PlugplayState.setHighestLastStepCompleted)
  public readonly setHighestLastStepCompleted: Emittable<number>
  depots: Depot[] = []
  filterDepots: number[] = []
  checkouts: Checkout[] = [new Checkout({ id: 0, name: 'all' })]
  onFilterDepotsChange(event: number[]) {
    this.filterDepots = event
  }
  constructor(private readonly core: CoreService) {
    this.setActive.emit(0)
    this.depots = this.core.lists.depots.filter(depot => {
      return depot.name !== 'all' && this.core.services.user?.user?.depots?.some(d => d.id === depot.id)
    })
    this.checkouts = this.checkouts.concat(
      this.core.lists.checkouts.filter(checkout =>
        this.core.services.user.user.checkouts.some(ch => ch.id === checkout.id),
      ),
    )
  }
}
